import declint from 'declint-ru'

const yearWordList = ['год', 'года', 'лет']

export default ({ age, ageYears }) => `${age} (${ageYears} ${declint(ageYears, yearWordList)})`
